const getters = {
  token: state => state.user.token,
  userId: state => state.user.userId,
  avatar: state => state.user.avatar,
  name: state => state.user.name,
  roles: state => state.user.roles,
  module: state => state.user.module,
  reportType: state => state.project.reportType
};
export default getters
